import { useQuery } from '@apollo/client';
import { gql } from '__generated__/gql';
import { FC } from 'react';

import ErrorMessage from 'components/ErrorMessage';

import LoadingIndicator from 'primitives/LoadingIndicator';

import NotificationCategoryMatrix from './NotificationCategoryMatrix';

const USER_NOTIFICATION_QUERY = gql(`
  query getUserNotificationSettings {
    dashboard {
      id
      user {
        id
        notificationPreferences {
          id
          emailEnabled
          smsEnabled
          whatsappEnabled
          platformEnabled
        }
        notificationCategoryPreferences {
          category
          subcategories {
            id
            category
            subcategory
            emailEnabled
            smsEnabled
            pushEnabled
            whatsappEnabled
          }
        }
      }
    }
  }
`);

const NotificationSettingsPage: FC = () => {
  const { loading, error, data, refetch } = useQuery(USER_NOTIFICATION_QUERY);

  if (loading) return <LoadingIndicator />;

  if (error || !data) return <ErrorMessage error={error} refetch={refetch} />;

  const user = data.dashboard.user;

  return (
    <NotificationCategoryMatrix
      userId={user.id}
      categories={user.notificationCategoryPreferences ?? []}
    />
  );
};

export default NotificationSettingsPage;
